<template>
  <div class="container-fluid py-4 px-4 ">
    <!-- Título -->

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-files display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            RENOVACIONES Y CONTRATOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO RENOVACION Y NO RENOVADOS
          </p>
        </div>
      </div>
    </div>
    <div class=" border border-1 rounded-3 p-3 mb-2 ">

      <div class="col-12 d-flex justify-content-end mt-2">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
            <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
            aria-label=".form-control-lg example" placeholder="Tipo de Documento" v-model="filterField"
            />
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th>ID</th>
              <th scope="col">TIPO DOCUMENTO</th>
              <th scope="col">RESPONSABLE DE CARGA</th>
              <th>ESTADO</th>
              <th scope="col">DOCUMENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="5" class="text-center align-middle" style="height: 200px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>
            <tr v-else v-for="(ListadoContratosInicio, index) in ListadoContratosInicio" :key="index.id"
              class="text-center align-middle reducirTamaño text-nowrap">

              <td>{{ ListadoContratosInicio.idDocumento }}</td>
              <td class="text-center">
                {{ ListadoContratosInicio.nomTipoDocumento }}
              </td>

              <td class="text-center">
                {{ ListadoContratosInicio.desProceso }}
              </td>
              <td class="text-center" :class="{
                'text-success fw-bold':
                  ListadoContratosInicio.renCodEstado == '003',
                'text-primary fw-bold':
                  ListadoContratosInicio.renCodEstado == '002',
                'text-warning fw-bold':
                  ListadoContratosInicio.renCodEstado == '001',
              }">
                {{ ListadoContratosInicio.desCodEstado }}
              </td>

              <td class="text-center py-0">
                <button class="btn btn-white border border-0 boton-estiloCuadrado" v-if="
                  ListadoContratosInicio.renCodEstado !== '002' &&
                  ListadoContratosInicio.renEstadopdf == 1 &&
                  ListadoContratosInicio.renEstadoAdjunto == 1
                ">
                  <a :href="url + ListadoContratosInicio.docAdjunto.split('Legajo\\')[1]" target="_blank">
                    <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                  </a>
                </button>

                <button class="btn btn-white border border-0 boton-estiloCuadrado" v-if="
                  ListadoContratosInicio.renCodEstado == '002' &&
                  ListadoContratosInicio.renEstadopdf == 1 &&
                  ListadoContratosInicio.renEstadoAdjunto == 0
                " @click="
                  showModales(
                    ListadoContratosInicio,
                    ListadoContratosInicio.docAdjunto.slice(52),
                    ListadoContratosInicio.idDocumento, ListadoContratosInicio.autorFirma
                  )
                  ">
                  <i class="bi bi-file-earmark-pdf text-danger fs-4"></i>
                </button>

                <button class="btn btn-white border border-0 boton-estiloCuadrado " v-if="
                  ListadoContratosInicio.renEstadopdf == 1 &&
                  ListadoContratosInicio.renEstadoAdjunto == 0 &&
                  ListadoContratosInicio.renCodEstado == '002'
                " @click="
                  showModales(
                    ListadoContratosInicio,
                    ListadoContratosInicio.docAdjunto.slice(52),
                    ListadoContratosInicio.idDocumento, ListadoContratosInicio.autorFirma
                  )
                  ">


                  <!-- @click="
                      ConfirmarContrato(ListadoContratosInicio.idDocumento)
                    " -->
                  <i class="bi bi-file-earmark-pdf-fill text-primary fs-4"></i>
                </button>


                <button class="btn btn-white border border-0" v-if="
                  ListadoContratosInicio.renEstadopdf == 1 &&
                  ListadoContratosInicio.renEstadoAdjunto == 1 &&
                  ListadoContratosInicio.renCodEstado == '002'
                ">
                  <i class="bi bi-file-earmark-pdf-fill text-success fs-4"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pagination-info small">Página {{ currentPage }} de {{ totalPages }}</span>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
      <b-modal v-model="showModal" size="xl" modal-class="custom-modal-body" title="Visualización PDF" hide-footer
        ok-only>
        <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
        <div class="d-flex">
          <!-- <b-form-checkbox
            v-if="!readCheckbox"
            class="mt-4"
            v-model="readCheckbox"
          >
            <p class="mx-2">marcar aqui </p>
          </b-form-checkbox> -->

          <b-button @click="FirmasDigitales = true" class="ms-2 mt-3 py-0 my-0" variant="success"><i
              class="bi bi-pencil"></i> Firma
            {{ FirmasDigitales }}</b-button>
        </div>
      </b-modal>

      <b-modal v-model="FirmasDigitales" size="sm" centered id="modal-center" modal-class="custom-modal-body"
        hide-footer ok-only @shown="inicializarCanvas">
        <h5>Firmar</h5>
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a class="nav-link active" href="#">Dibujar</a>
          </li>
          <!-- <li class="nav-item">
                <a class="nav-link " href="#">Escribir</a>
              </li> -->
        </ul>

        <div class="p-0 mb-3">
          <canvas ref="canvas" width="100%" height="550" style="
                  width: 100%;
                  height: 250px;
                  border: 1px dashed #007bff;
                  cursor: crosshair;
                "></canvas>
        </div>

        <div class="d-flex justify-content-between">
          <button class="btn btn-secondary" @click="limpiarFirma">
            Limpiar
          </button>
          <button class="btn btn-primary" @click="guardarFirma">
            Firmar documentos
          </button>
        </div>
      </b-modal>
      <!-- </b-tab> -->

      <!-- <b-tab title="Boletas">
          <p>Boletas</p>
        </b-tab>

        <b-tab title="Vacaciones">
          <p>Vacaciones</p>
        </b-tab> -->
      <!-- </b-tabs> -->

    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'CopiasContratoRenovaciones',

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Legajo/",
      showModal: false,
      pdfUrl: "",
      dibujando: false,
      ctx: null,
      FirmasDigitales: false,
      idDni: "",
      autorFirma: "",
      pdf: null,
      filterField: '',
      loading: false,
      currentPage: 1,
      itemsPerPage: 10,
       filteredList: [],

    };
  },

  mounted() { },

  computed: {
    ...mapGetters("users", ["ListadoContratosInicio"]),
    ...mapGetters("renovaciones", ["ItemsGestion"]),

    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },
    paginatedList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredList.slice(start, end);
    },

  },
  created() {
    this.cambiarEstadoNavbar();
  },
  methods: {
    ...mapActions("users", ["getAttributes"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    inicializarCanvas() {
      const canvas = this.$refs.canvas;
      if (!canvas) {
        console.warn("Canvas no encontrado.");
        return;
      }
      const containerWidth = canvas.parentElement.offsetWidth;
      const canvasHeight = 250;

      // 🔧 Tamaño interno del lienzo en píxeles reales
      canvas.width = containerWidth;
      canvas.height = canvasHeight;
      this.ctx = canvas.getContext("2d");

      canvas.addEventListener("mousedown", this.empezarDibujo);
      canvas.addEventListener("mousemove", this.dibujar);
      canvas.addEventListener("mouseup", this.terminarDibujo);
      canvas.addEventListener("mouseout", this.terminarDibujo);
    },
    showModales(json, ruta, idDni, autorFirma) {
      this.DescargarPdf(json)
      this.idDni = idDni;
      this.autorFirma = autorFirma
      this.showModal = true;
      this.pdfUrl = this.url + ruta;
      this.pdfUrl = this.url + localStorage.getItem('dniUsers') + "/" + "sn" + this.idDni + ".pdf"
    },


    empezarDibujo(e) {
      this.dibujando = true;
      this.ctx.beginPath();
      this.ctx.moveTo(e.offsetX, e.offsetY);
    },
    dibujar(e) {
      if (!this.dibujando) return;
      this.ctx.lineTo(e.offsetX, e.offsetY);
      this.ctx.stroke();
    },
    terminarDibujo() {
      this.dibujando = false;
      this.ctx.closePath();
    },
    limpiarFirma() {
      const canvas = this.$refs.canvas;
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    },
    guardarFirma() {
      const canvas = this.$refs.canvas;
      const dataUrl = canvas.toDataURL("image/png");
      const payload = {
        firmaBase64: dataUrl,
        NroDocumento: `${localStorage.getItem("dniUsers")}`,
      };
      this.axios
        .post(`Contrato/GuardarFirma`, payload)
        .then((res) => {
          if (res.data.estado) {
            this.axios
              .put(`Contrato/ActualizarEstadoPdf?idRenovacion=${this.idDni}`)
              .then((r) => {
                if (r.data) {
                  this.getAttributes();
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Firma Registrada",
                    showConfirmButton: true,
                  }).then(() => {
                    // Esto se ejecuta DESPUÉS de que el usuario presiona "Aceptar"
                    this.showModal = false;
                    this.axios
                      .get(
                        `Contrato/InsertarFirmaTrabajador?idRenovacion=${this.idDni}&autorFirma=${this.autorFirma}&dni=${localStorage.getItem("dniUsers")}`
                      )
                      .then((r) => {
                        console.log(r.data);
                      });
                  });
                  this.FirmasDigitales = false;
                }
              });
          }
        })
        .catch((err) => {
          console.error("❌ Error:", err);
        });
      // Puedes emitir un evento al padre o enviarlo por Axios:
      // this.$emit('firmaGuardada', dataUrl)
    },

    DescargarPdf(items) {
      console.log("no llega aqui", items)
      for (let index of this.ItemsGestion) {
        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual == index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("hola1");
          console.log(index);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarPdf?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&SubSubCentro=${items.subSubCentroCostos}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log(r);
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("se cambio el sueldo");
          console.log(items);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto != index.idPuestoNuevo &&
          items.idTrabajador == index.idTrabajador &&
          index.renSueldoActual == index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("se cambio el puesto");
          console.log(items.nomLargoEmp);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto !== index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("see cambiaron los dos");
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }
      }
    },

    GenerarPdf(filename) {
      var fileURL = window.URL.createObjectURL(new Blob([this.pdf.data]));
      var fileLink = document.createElement("a");

      console.log(filename);
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${filename}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
      window.URL.revokeObjectURL(fileURL);
    },

    // ConfirmarContrato(id) {
    //   this.axios
    //     .put(`Contrato/ActualizarEstadoAdjuntoPdf?idRenovacion=${id}`)
    //     .then((r) => {
    //       console.log(r.data);
    //       if (r.data) {
    //         this.getAttributes();
    //         Swal.fire({
    //           position: "center",
    //           icon: "success",
    //           title: "rabajador Renovado",
    //           showConfirmButton: true,
    //         });
    //       }
    //     });
    // },
  },
};
</script>

<style scoped>
.border-dashed {
  border-style: dashed !important;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: #0080c8;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
